import { createRouter, createWebHistory } from 'vue-router';
import type { RouteMetadata } from '@/types/components';

declare module 'vue-router' {
  interface RouteMeta extends RouteMetadata {}
}

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    meta: {
      title: 'Program Yayasan Surabaya Mengaji Official',
      description:
        'Yayasan Surabaya Mengaji Official (YSMO) bergerak di bidang dakwah, pendidikan, sosial, dan usaha. Jelajahi program-program kami untuk umat di Surabaya dan sekitarnya.',
      keywords:
        'Surabaya Mengaji, YSMO, Yayasan Surabaya Mengaji Official, dakwah Islam, pendidikan Islam, kegiatan sosial, usaha Islam, program Islam, Surabaya, ngaji Surabaya',
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, _from, next) => {
  // Set document title
  document.title =
    to.meta?.title || 'Program Yayasan Surabaya Mengaji Official';

  // Update meta description
  const metaDescription = document.querySelector(
    'meta[name="description"]'
  ) as HTMLMetaElement;
  if (metaDescription && to.meta?.description) {
    metaDescription.content = to.meta.description;
  }

  // Update meta keywords
  const metaKeywords = document.querySelector(
    'meta[name="keywords"]'
  ) as HTMLMetaElement;
  if (metaKeywords && to.meta?.keywords) {
    metaKeywords.content = to.meta.keywords;
  }

  next();
});

export default router;
